{
  "actionButtons": {
    "export": "Exportieren",
    "exportAsCsv": "als CSV",
    "exportAsPdf": "als PDF"
  },
  "areYouSureModal": {
    "cancelText": "Abbrechen",
    "confirmText": "Bestätigen",
    "title": "Aktion bestätigen"
  },
  "copy": "{{text}} in die Zwischenablage kopiert",
  "countries": {
    "AC": "Ascension Island",
    "AD": "Andorra",
    "AE": "Vereinigte Arabische Emirate",
    "AF": "Afghanistan",
    "AG": "Antigua & Barbuda",
    "AI": "Anguilla",
    "AL": "Albanien",
    "AM": "Armenien",
    "AO": "Angola",
    "AQ": "Antarktis",
    "AR": "Argentinien",
    "AS": "Amerikanisch-Samoa",
    "AT": "Österreich",
    "AU": "Australien",
    "AW": "Aruba",
    "AX": "Åland-Inseln",
    "AZ": "Aserbaidschan",
    "BA": "Bosnien & Herzegowina",
    "BB": "Barbados",
    "BD": "Bangladesch",
    "BE": "Belgien",
    "BF": "Burkina Faso",
    "BG": "Bulgarien",
    "BH": "Bahrain",
    "BI": "Burundi",
    "BJ": "Benin",
    "BL": "St. Barthélemy",
    "BM": "Bermuda",
    "BN": "Brunei",
    "BO": "Bolivien",
    "BQ": "Karibische Niederlande",
    "BR": "Brasilien",
    "BS": "Bahamas",
    "BT": "Bhutan",
    "BV": "Bouvet Island",
    "BW": "Botswana",
    "BY": "Belarus",
    "BZ": "Belize",
    "CA": "Kanada",
    "CC": "Kokosinseln",
    "CD": "Kongo - Kinshasa",
    "CF": "Zentralafrikanische Republik",
    "CG": "Kongo - Brazzaville",
    "CH": "Schweiz",
    "CI": "Elfenbeinküste",
    "CK": "Cookinseln",
    "CL": "Chile",
    "CM": "Kamerun",
    "CN": "China",
    "CO": "Kolumbien",
    "CP": "Clipperton Island",
    "CR": "Costa Rica",
    "CU": "Kuba",
    "CV": "Kap Verde",
    "CW": "Curaçao",
    "CX": "Weihnachtsinsel",
    "CY": "Zypern",
    "CZ": "Tschechien",
    "DE": "Deutschland",
    "DG": "Diego Garcia",
    "DJ": "Dschibuti",
    "DK": "Dänemark",
    "DM": "Dominica",
    "DO": "Dominikanische Republik",
    "DZ": "Algerien",
    "EA": "Ceuta & Melilla",
    "EC": "Ecuador",
    "EE": "Estland",
    "EG": "Ägypten",
    "EH": "Westsahara",
    "ER": "Eritrea",
    "ES": "Spanien",
    "ET": "Äthiopien",
    "EU": "Europäische Union",
    "FI": "Finnland",
    "FJ": "Fidschi",
    "FK": "Falklandinseln",
    "FM": "Mikronesien",
    "FO": "Färöer",
    "FR": "Frankreich",
    "GA": "Gabun",
    "GB": "Vereinigtes Königreich",
    "GD": "Grenada",
    "GE": "Georgien",
    "GF": "Französisch-Guayana",
    "GG": "Guernsey",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GL": "Grönland",
    "GM": "Gambia",
    "GN": "Guinea",
    "GP": "Guadeloupe",
    "GQ": "Äquatorialguinea",
    "GR": "Griechenland",
    "GS": "Südgeorgien & Südliche Sandwichinseln",
    "GT": "Guatemala",
    "GU": "Guam",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HK": "Hongkong",
    "HM": "Heard & McDonald Islands",
    "HN": "Honduras",
    "HR": "Kroatien",
    "HT": "Haiti",
    "HU": "Ungarn",
    "IC": "Kanarische Inseln",
    "ID": "Indonesien",
    "IE": "Irland",
    "IL": "Israel",
    "IM": "Isle of Man",
    "IN": "Indien",
    "IO": "Britisches Territorium im Indischen Ozean",
    "IQ": "Irak",
    "IR": "Iran",
    "IS": "Island",
    "IT": "Italien",
    "JE": "Jersey",
    "JM": "Jamaika",
    "JO": "Jordanien",
    "JP": "Japan",
    "KE": "Kenia",
    "KG": "Kirgisistan",
    "KH": "Kambodscha",
    "KI": "Kiribati",
    "KM": "Komoren",
    "KN": "St. Kitts & Nevis",
    "KP": "Nordkorea",
    "KR": "Südkorea",
    "KW": "Kuwait",
    "KY": "Kaimaninseln",
    "KZ": "Kasachstan",
    "LA": "Laos",
    "LB": "Libanon",
    "LC": "St. Lucia",
    "LI": "Liechtenstein",
    "LK": "Sri Lanka",
    "LR": "Liberia",
    "LS": "Lesotho",
    "LT": "Litauen",
    "LU": "Luxemburg",
    "LV": "Lettland",
    "LY": "Libyen",
    "MA": "Marokko",
    "MC": "Monaco",
    "MD": "Moldau",
    "ME": "Montenegro",
    "MF": "St. Martin",
    "MG": "Madagaskar",
    "MH": "Marshallinseln",
    "MK": "Nordmazedonien",
    "ML": "Mali",
    "MM": "Myanmar (Burma)",
    "MN": "Mongolei",
    "MO": "Macau",
    "MP": "Nördliche Marianen",
    "MQ": "Martinique",
    "MR": "Mauretanien",
    "MS": "Montserrat",
    "MT": "Malta",
    "MU": "Mauritius",
    "MV": "Malediven",
    "MW": "Malawi",
    "MX": "Mexiko",
    "MY": "Malaysia",
    "MZ": "Mosambik",
    "NA": "Namibia",
    "NC": "Neukaledonien",
    "NE": "Niger",
    "NF": "Norfolkinsel",
    "NG": "Nigeria",
    "NI": "Nicaragua",
    "NL": "Niederlande",
    "NO": "Norwegen",
    "NP": "Nepal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "Neuseeland",
    "OM": "Oman",
    "PA": "Panama",
    "PE": "Peru",
    "PF": "Französisch-Polynesien",
    "PG": "Papua-Neuguinea",
    "PH": "Philippinen",
    "PK": "Pakistan",
    "PL": "Polen",
    "PM": "St. Pierre & Miquelon",
    "PN": "Pitcairninseln",
    "PR": "Puerto Rico",
    "PS": "Palästinensische Gebiete",
    "PT": "Portugal",
    "PW": "Palau",
    "PY": "Paraguay",
    "QA": "Katar",
    "RE": "Réunion",
    "RO": "Rumänien",
    "RS": "Serbien",
    "RU": "Russland",
    "RW": "Ruanda",
    "SA": "Saudi-Arabien",
    "SB": "Salomonen",
    "SC": "Seychellen",
    "SD": "Sudan",
    "SE": "Schweden",
    "SG": "Singapur",
    "SH": "St. Helena",
    "SI": "Slowenien",
    "SJ": "Svalbard & Jan Mayen",
    "SK": "Slowakei",
    "SL": "Sierra Leone",
    "SM": "San Marino",
    "SN": "Senegal",
    "SO": "Somalia",
    "SR": "Suriname",
    "SS": "Südsudan",
    "ST": "São Tomé & Príncipe",
    "SV": "El Salvador",
    "SX": "Sint Maarten",
    "SY": "Syrien",
    "SZ": "Eswatini",
    "TA": "Tristan da Cunha",
    "TC": "Turks- und Caicosinseln",
    "TD": "Tschad",
    "TF": "Französische Südgebiete",
    "TG": "Togo",
    "TH": "Thailand",
    "TJ": "Tadschikistan",
    "TK": "Tokelau",
    "TL": "Osttimor",
    "TM": "Turkmenistan",
    "TN": "Tunesien",
    "TO": "Tonga",
    "TR": "Türkei",
    "TT": "Trinidad & Tobago",
    "TV": "Tuvalu",
    "TW": "Taiwan",
    "TZ": "Tansania",
    "UA": "Ukraine",
    "UG": "Uganda",
    "UM": "Amerikanische Überseeinseln",
    "UN": "Unbekannt",
    "US": "Vereinigte Staaten",
    "UY": "Uruguay",
    "UZ": "Usbekistan",
    "VA": "Vatikanstadt",
    "VC": "St. Vincent & Grenadinen",
    "VE": "Venezuela",
    "VG": "Britische Jungferninseln",
    "VI": "Amerikanische Jungferninseln",
    "VN": "Vietnam",
    "VU": "Vanuatu",
    "WF": "Wallis & Futuna",
    "WS": "Samoa",
    "XK": "Kosovo",
    "YE": "Jemen",
    "YT": "Mayotte",
    "ZA": "Südafrika",
    "ZM": "Sambia",
    "ZW": "Simbabwe"
  },
  "countriesEcobalyse": {
    "BD": "Bangladesch",
    "CN": "China",
    "FR": "Frankreich",
    "IN": "Indien",
    "KH": "Kambodscha",
    "MA": "Marokko",
    "MM": "Myanmar",
    "PK": "Pakistan",
    "RAF": "Afrika-Region",
    "RAS": "Asien-Region",
    "REE": "Osteuropäische Region",
    "REO": "Westeuropäische Region",
    "RLA": "Lateinamerika-Region",
    "RME": "Naher Osten-Region",
    "RNA": "Nordamerika-Region",
    "ROC": "Ozeanien-Region",
    "TN": "Tunesien",
    "TR": "Türkei",
    "VN": "Vietnam"
  },
  "dataLoad": {
    "error": {
      "message": "Beim Laden der Liste ist etwas schiefgelaufen. Bitte versuchen Sie es später erneut.",
      "title": "Etwas ist schiefgelaufen"
    },
    "noResults": {
      "message": "Wir konnten keine Datensätze für Ihre Organisation finden. Bitte versuchen Sie es erneut.",
      "title": "Keine Ergebnisse"
    }
  },
  "documentUpload": {
    "helptext": "Maximale Größe: {{ maxSize }} MB",
    "title": "Ziehen Sie Ihre Dateien hierher oder klicken Sie, um Dateien auszuwählen",
    "uploadSuppliers": "Datei vorprüfen"
  },
  "error": {
    "default": "Ein Fehler ist aufgetreten"
  },
  "fabricProcess": {
    "knitting-circular": "Rundstricken",
    "knitting-fully-fashioned": "Vollgestrickt",
    "knitting-integral": "Integrales Stricken",
    "knitting-mix": "Strickmischung",
    "knitting-straight": "Gerades Stricken",
    "weaving": "Weben"
  },
  "filter": "Filter",
  "filter_false": "Nein",
  "filter_true": "Ja",
  "languages": {
    "arabic": "Arabisch",
    "belarusian": "Belarussisch",
    "chinese": "Chinesisch",
    "dutch": "Niederländisch",
    "english": "Englisch",
    "french": "Französisch",
    "german": "Deutsch",
    "italian": "Italienisch",
    "japanese": "Japanisch",
    "korean": "Koreanisch",
    "lithuanian": "Litauisch",
    "portuguese": "Portugiesisch",
    "romanian": "Rumänisch",
    "spanish": "Spanisch",
    "turkish": "Türkisch"
  },
  "lists": {
    "noData": {
      "message": "Für diese Ansicht sind noch keine Daten verfügbar.",
      "title": "Keine Daten"
    }
  },
  "menus": {
    "admin": "Back Office",
    "businessPartners": "Geschäftspartner",
    "certificates": "Dokumente",
    "communicationStudio": "Studio: Ihr zentraler Hub zur Gestaltung und Kontrolle, wie Produktinformationen Ihren Endverbrauchern angezeigt werden. Es ermöglicht Ihnen, Inhalte zu verwalten, Übersetzungen zu konfigurieren, Layout-Strukturen zu definieren und dynamische Regeln einzurichten, um Markenintegrität zu bewahren und konsistente Storytelling über Ihre Tools (Websites, Stores, etc.) zu gewährleisten.",
    "dashboard": "Dashboard",
    "dataTransfer": "Data Hub",
    "faq": "FAQ",
    "invoices": "Meine Rechnungen",
    "logout": "Abmelden",
    "products": "Katalog",
    "profile": "Mein Profil",
    "regulations": "Vorschriften"
  },
  "showOnlyMainFabric": "Hauptkomponente",
  "sort": {
    "ascending": "Aufsteigend",
    "descending": "Absteigend",
    "search": {
      "placeholder": "Suchen"
    },
    "title": "Sortieren"
  },
  "supplier": {
    "footer": {
      "privacyPolicy": "Datenschutzrichtlinie"
    },
    "menu": {
      "contacts": "Geschäftspartner",
      "documentation": "Dokumentation",
      "loggedAs": "Sie sind angemeldet als",
      "productionSites": "Produktionsstandorte",
      "requests": "Anfragen",
      "supplierRequests": "Lieferanten"
    }
  },
  "table": {
    "pinColumn": "Spalte anheften",
    "rowsPerPage": "Zeilen pro Seite",
    "total": "Gesamt: ",
    "unpinColumn": "Spalte lösen",
    "views": {
      "add": {
        "error": {
          "message": "Fehler beim Erstellen der Ansicht",
          "title": "Fehler beim Erstellen der Ansicht"
        },
        "success": {
          "message": "Ansicht erstellt erfolgreich",
          "title": "Ansicht erstellt"
        }
      },
      "delete": {
        "error": {
          "message": "Fehler beim Löschen der Ansicht",
          "title": "Fehler beim Löschen der Ansicht"
        },
        "modal": {
          "cancel": "Abbrechen",
          "delete": "Löschen",
          "description": "Sind Sie sicher, dass Sie die Ansicht {{viewName}} löschen möchten? Diese Aktion ist irreversibel.",
          "title": "Bestätigung"
        },
        "success": {
          "message": "Ansicht gelöscht erfolgreich",
          "title": "Ansicht gelöscht"
        }
      },
      "modal": {
        "title": "Aktive Ansicht",
        "description": "Speichern Sie die aktive Ansicht der Datentabelle, um sie später wiederzufinden. Die Sortierung, Filterung und Spaltenkonfiguration werden gespeichert.",
        "update": "Aktualisieren",
        "save": "Speichern",
        "reset": "Zurücksetzen"
      },
      "update": {
        "error": {
          "message": "Fehler beim Aktualisieren der Ansicht",
          "title": "Fehler beim Aktualisieren der Ansicht"
        },
        "success": {
          "message": "Ansicht aktualisiert erfolgreich",
          "title": "Ansicht aktualisiert"
        }
      },
      "viewName": "Ansichtsname",
      "viewNamePlaceholder": "Geben Sie den Ansichtsname ein"
    }
  },
  "zodErrors": {
    "errorDefault": "Ungültiger Wert",
    "invalidEmail": "Ungültige E-Mail-Adresse",
    "noSpecialCharacters": "Der Wert muss mehr als 2 Zeichen enthalten und darf keine Sonderzeichen enthalten",
    "ValueTooLong": "Wert zu lang",
    "ValueTooShort": "Wert zu kurz",
    "mustContainBothLatitudeAndLongitude": "Sowohl Breitengrad als auch Längengrad müssen angegeben werden",
    "longitudeOutOfRange": "Der Längengrad muss zwischen -180 und +180 liegen",
    "latitudeOutOfRange": "Der Breitengrad muss zwischen -90 und +90 liegen",
    "latitudeAndLongitudeOutOfRange": "Sowohl Breitengrad als auch Längengrad liegen außerhalb des gültigen Bereichs"
  }
}
